import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AddGroupContactDialogueHandler } from '../types';
import AddGroupContactDialogueContext from './AddGroupContactContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type AddGroupContactDialogueProps = {
  handleDialogue: DialogueHandler<AddGroupContactDialogueHandler>;
};

type FC = FunctionComponent<AddGroupContactDialogueProps>;

const AddGroupContactDialogue: FC = ({ handleDialogue }: AddGroupContactDialogueProps) => {
  const { showAddGroupContactErrorAlert, addGroupContactError } = useContext(AddGroupContactDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Details.Contacts.GroupCreationErrorDialog' });

  return useMemo(
    () => (
      <div>
        {/* Group Creation Error */}
        <ConfirmationDialogue
          isVisible={showAddGroupContactErrorAlert}
          title={t('title')}
          status="error"
          subTitle={`${addGroupContactError}`}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showAddGroupContactErrorAlert, addGroupContactError],
  );
};

export default AddGroupContactDialogue;
